module.exports = __webpack_public_path__ + "img/msource_msourcetoken.682e7e4.png";